module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Component1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Your name (2)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.name),
      expression: "localPerson.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.localPerson.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputProfession"
    }
  }, [_vm._v("Your profession (2)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPerson.profession),
      expression: "localPerson.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProfession",
      "placeholder": "Profession"
    },
    domProps: {
      "value": (_vm.localPerson.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localPerson.profession = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.revert
    }
  }, [_vm._v("Revert")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.savePerson2(_vm.localPerson)
      }
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), (_vm.apiError) ? _c('div', {
    staticClass: "col-sm-offset-3 error"
  }, [_vm._v("\n      " + _vm._s(_vm.apiError) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-651be6d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component2.vue
// module id = 111
// module chunks = 1